import { t } from '../i18n';
const Cennik = () => {
    return (
        <div className="cennik-container">
            <table className="pricelist-table">
                <thead>
                    <tr>
                        <td>{t("Usługi podstawowe")}</td>
                        <td>{t("Mały")}</td>
                        <td>{t("Standard")}</td>
                        <td>{t("SUV")}</td>
                        <td>{t("Duży SUV/VAN")}</td>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>{t("Mycie zewnętrzne")}</td><td>{t("100 zł")}</td><td>{t("110 zł")}</td><td>{t("120 zł")}</td><td>{t("140 zł")}</td></tr>
                    <tr><td>{t("Pielęgnacja wnętrza")}</td><td>{t("100 zł")}</td><td>{t("110 zł")}</td><td>{t("120 zł")}</td><td>{t("140 zł")}</td></tr>
                    <tr><td>{t("Komplet")}</td><td>{t("180 zł")}</td><td>{t("200 zł")}</td><td>{t("220 zł")}</td><td>{t("240 zł")}</td></tr>
                </tbody>
                <thead>
                    <tr>
                        <td colSpan={5}>{t("Pakiety")}</td>
                    </tr>
                </thead>
                <tbody>
                    {/* pakiety */}
                    <tr><td>{t("Komplet z płynnym woskiem")}</td><td>{t("210 zł")}</td><td>{t("240 zł")}</td><td>{t("260 zł")}</td><td>{t("300 zł")}</td></tr>
                    <tr><td>{t("Komplet z powłoką polimerową")}</td><td>{t("250 zł")}</td><td>{t("270 zł")}</td><td>{t("300 zł")}</td><td>{t("330 zł")}</td></tr>
                    <tr><td>{t("Komplet z twardym woskiem")}</td><td>{t("380 zł")}</td><td>{t("400 zł")}</td><td>{t("420 zł")}</td><td>{t("450 zł")}</td></tr>
                    <tr><td>{t("Komplet z powłoką teflonową")}</td><td>{t("420 zł")}</td><td>{t("440 zł")}</td><td>{t("460 zł")}</td><td>{t("490 zł")}</td></tr>
                    <tr><td>{t("Pakiet \"HYDROFOBOWOŚĆ\"")}</td><td>{t("530 zł")}</td><td>{t("550 zł")}</td><td>{t("590 zł")}</td><td>{t("620 zł")}</td></tr>
                    <tr><td>{t("Pakiet \"ZABEZPIECZENIE\"")}</td><td>{t("570 zł")}</td><td>{t("590 zł")}</td><td>{t("610 zł")}</td><td>{t("640 zł")}</td></tr>
                    <tr><td>{t("Pakiet \"POŁYSK\"")}</td><td>{t("530 zł")}</td><td>{t("550 zł")}</td><td>{t("590 zł")}</td><td>{t("620 zł")}</td></tr>
                    <tr><td>{t("Pakiet pielęgnacji wnętrza z praniem foteli lub czyszczeniem foteli skórzanych")}</td><td>{t("od 380 zł")}</td><td>{t("od 390 zł")}</td><td>{t("od 400 zł")}</td><td>{t("od 430 zł")}</td></tr>
                    <tr><td>{t("Pakiet kompleksowej pielęgnacji wnętrza")}</td><td>{t("od 630 zł")}</td><td>{t("od 680 zł")}</td><td>{t("od 830 zł")}</td><td>{t("od 870 zł")}</td></tr>
                    <tr><td>{t("Pakiet kompleksowej pielęgnacji samochodu")}</td><td>{t("od 1100 zł")}</td><td>{t("od 1300 zł")}</td><td>{t("od 1600 zł")}</td><td>{t("od 2000 zł")}</td></tr>
                </tbody>
            </table>
            <table className="pricelist-table pricelist-table2">
                <thead>
                    <tr>
                        <td colSpan={2}>{t("Usługi dodatkowe - zewnętrze")}</td>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>{t("Aplikacja powłoki hydrofobowej na szyby (komplet)")}</td><td>{t("190 zł")}</td></tr>
                    <tr><td>{t("Aplikacja powłoki teflonowej na felgi (komplet)")}</td><td>{t("80-140 zł")}</td></tr>
                    <tr><td>{t("Aplikacja powłoki na zewnętrze elementy plastikowe (Nano Hard Plastic)")}</td><td>{t("50-200 zł")}</td></tr>
                    <tr><td>{t("Aplikacja powłoki ochronnej na reflektory (Nano Hard Clear)")}</td><td>{t("90 zł")}</td></tr>
                    <tr><td>{t("Zabezpieczenie elementów chromowanych")}</td><td>{t("od 40 zł")}</td></tr>
                    <tr><td>{t("Aplikacja powłoki lub wosku na opony (Black Black, Tire Wax, 4X-Cleaner)")}</td><td>{t("60 zł")}</td></tr>
                    <tr><td>{t("Aplikacja powłoki hydrofobowej na lusterka zewnętrzne (Glaco Mirror Coat Zero)")}</td><td>{t("40 zł")}</td></tr>
                    <tr><td>{t("Usuwanie chemiczne i mechaniczne owadów (glinkowanie oraz Micro Liquid Compound)")}</td><td>{t("od 50 zł")}</td></tr>
                    <tr><td>{t("Dekontaminacja, usuwanie smoły oraz asfaltu z lakieru")}</td><td>{t("170-250 zł")}</td></tr>
                    <tr><td>{t("Usuwanie naklejek")}</td><td>{t("15-30 zł")}</td></tr>
                    <tr><td>{t("Czyszczenie elementów chromowanych")}</td><td>{t("od 20 zł")}</td></tr>
                    <tr><td>{t("Usuwanie chemiczne osadu od twardej wody (Micro Liquid Compound)")}</td><td>{t("100-200 zł")}</td></tr>
                    <tr><td>{t("Usuwanie żywicy z lakieru")}</td><td>{t("od 20 zł")}</td></tr>
                    <tr><td>{t("Oczyszczanie chemiczne szyb z osadów (Glass Compound Z)")}</td><td>{t("50-150 zł")}</td></tr>
                    <tr><td>{t("Motocykl")}</td><td>{t("200 zł")}</td></tr>
                </tbody>
                <thead>
                    <tr>
                        <td colSpan={2}>{t("Usługi dodatkowe - wewnętrzne")}</td>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>{t("Pranie foteli (cena za 1 fotel)")}</td><td>{t("90 zł")}</td></tr>
                    <tr><td>{t("Pranie elementów tapicerki (boczki drzwi podłokietnik etc.)")}</td><td>{t("80-120 zł")}</td></tr>
                    <tr><td>{t("Pranie słupków oraz podsufitki")}</td><td>{t("100-140 zł")}</td></tr>
                    <tr><td>{t("Pranie podłogi")}</td><td>{t("100-140 zł")}</td></tr>
                    <tr><td>{t("Czyszczenie i konserwacja elementów tapicerki skórzanej (kierownica, boczki, drzwi, podłokietnik etc.)")}</td><td>{t("70-250 zł")}</td></tr>
                    <tr><td>{t("Czyszczenie i konserwacja foteli skórzanych (cena za 1 fotel)")}</td><td>{t("90 zł")}</td></tr>
                    <tr><td>{t("Pranie dywaników (komplet)")}</td><td>{t("60 zł")}</td></tr>
                    <tr><td>{t("Czyszczenie dywaników gumowych (komplet)")}</td><td>{t("60 zł")}</td></tr>
                    <tr><td>{t("Czyszczenie i pielęgnacja komory silnika")}</td><td>{t("100 zł")}</td></tr>
                    <tr><td>{t("Ozonowanie wnetrza")}</td><td>{t("100 zł")}</td></tr>
                    <tr><td>{t("Zabezpieczenie elementów materiałowych powłoką Fusso (fotele, dywaniki, podłoga)")}</td><td>{t("190 zł")}</td></tr>
                    <tr><td>{t("Usuwanie sierści")}</td><td>{t("od 50 zł")}</td></tr>
                </tbody>
            </table>
            {/* <table className="pricelist-table pricelist-table2">
                <thead>
                    <tr>
                        <td colSpan={2}>Wymiana opon</td>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>Felgi stalowe 12''</td><td>120 zł</td></tr>
                    <tr><td>Felgi stalowe 13''</td><td>140 zł</td></tr>
                    <tr><td>Felgi stalowe 14''</td><td>150 zł</td></tr>
                    <tr><td>Felgi stalowe 15''</td><td>170 zł</td></tr>
                    <tr><td>Felgi stalowe 16''</td><td>180 zł</td></tr>
                    <tr><td>Felgi stalowe 17''</td><td>200 zł</td></tr>
                    <tr><td>Felgi stalowe 18''</td><td>200 zł</td></tr>
                    <tr><td>Felgi stalowe 19'' i większe</td><td>220 zł</td></tr>
                    <tr><td>Felgi stalowe dostawcze</td><td>220 zł</td></tr>
                    <tr><td>Felgi stalowe 4X4</td><td>+20 zł od koła</td></tr>
                    <tr><td>Felgi stalowe RUN FLAT</td><td>+20 zł od koła</td></tr>
                    <tr><td>Felgi aluminiowe 12''</td><td>140 zł</td></tr>
                    <tr><td>Felgi aluminiowe 13''</td><td>150 zł</td></tr>
                    <tr><td>Felgi aluminiowe 14''</td><td>160 zł</td></tr>
                    <tr><td>Felgi aluminiowe 15''</td><td>175 zł</td></tr>
                    <tr><td>Felgi aluminiowe 16''</td><td>195 zł</td></tr>
                    <tr><td>Felgi aluminiowe 17''</td><td>215 zł</td></tr>
                    <tr><td>Felgi aluminiowe 18''</td><td>240 zł</td></tr>
                    <tr><td>Felgi aluminiowe 19''</td><td>260 zł</td></tr>
                    <tr><td>Felgi aluminiowe 20''</td><td>280 zł</td></tr>
                    <tr><td>Felgi aluminiowe 21''</td><td>290 zł</td></tr>
                    <tr><td>Felgi aluminiowe 22'' i większe</td><td>320 zł</td></tr>
                    <tr><td>Felgi aluminiowe dostawcze</td><td>od 240 zł</td></tr>
                    <tr><td>Felgi aluminiowe 4X4</td><td>+20 zł od koła</td></tr>
                    <tr><td>Felgi aluminiowe RUN FLAT</td><td>+20 zł od koła</td></tr>
                    <tr><td>Wymiana całych kół</td><td>od 150 zł</td></tr>
                    <tr><td>Wyważanie</td><td>od 150 zł za komplet</td></tr>
                    <tr><td>Utylizacja opony</td><td>30 zł</td></tr>
                    <tr><td>Hotel dla opon</td><td>149 zł</td></tr>
                </tbody>

                <thead>
                    <tr>
                        <td colSpan={2}>Układ klimatyzacji: czynnik r134a</td>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>podłączenie maszyny TEXA</td><td>150 zł</td></tr>
                    <tr><td>plus opłata za czynnik (100g)</td><td>50 zł</td></tr>
                </tbody>

                <thead>
                    <tr>
                        <td colSpan={2}>Układ klimatyzacji: czynnik R1234</td>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>podłączenie maszyny TEXA</td><td>150 zł</td></tr>
                    <tr><td>plus opłata za czynnik (100g)</td><td>100 zł</td></tr>
                </tbody>

                <thead>
                    <tr>
                        <td colSpan={2}>Serwis okresowy samochodu</td>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>wymiana oleju silnikowego z filtrem oleju</td><td>od 100 zł</td></tr>
                    <tr><td>wymiana filtra paliwa</td><td>od 60 zł</td></tr>
                    <tr><td>wymiana filtra powietrza</td><td>od 20 zł</td></tr>
                    <tr><td>wymiana filtra kabinowego</td><td>od 60 zł</td></tr>
                </tbody>

                <thead>
                    <tr>
                        <td colSpan={2}>Geometria w technologii 3D</td>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>przednia oś</td><td>150 zł</td></tr>
                    <tr><td>przednia i tylna oś</td><td>200 zł</td></tr>
                </tbody>

                <thead>
                    <tr>
                        <td colSpan={2}>Układ hamulcowy samochodu</td>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>klocki przednia oś</td><td>od 100 zł</td></tr>
                    <tr><td>klocki tylnia oś</td><td>od 100 zł</td></tr>
                    <tr><td>klocki tylnia oś z cofaniem tłoczków elektrycznych</td><td>od 150 zł</td></tr>
                    <tr><td>tarcze hamulcowe z klockami przednia oś</td><td>od 120 zł</td></tr>
                    <tr><td>tarcze hamulcowe z klockami tylnia oś</td><td>od 120 zł</td></tr>
                    <tr><td>tarcze hamulcowe z klockami tylnia oś z cofaniem tłoczków</td><td>od 170 zł</td></tr>
                    <tr><td>bębny hamulcowe tylnia oś</td><td>od 150 zł</td></tr>
                </tbody>

                <thead>
                    <tr>
                        <td colSpan={2}>Układ zawieszenia samochodu - wymiana</td>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>amortyzatora</td><td>od 120 zł</td></tr>
                    <tr><td>sprężyny</td><td>od 120 zł</td></tr>
                    <tr><td>amortyzatora ze sprężyną</td><td>od 130 zł</td></tr>
                    <tr><td>końcówki drążka kierowniczego</td><td>od 100 zł</td></tr>
                    <tr><td>sworznia</td><td>od 70 zł</td></tr>
                    <tr><td>łącznika stabilizatora</td><td>od 50 zł</td></tr>
                    <tr><td>gumy łącznika stabilizatora</td><td>od 70 zł</td></tr>
                    <tr><td>osłony przegubu i przegubu</td><td>od 150 zł</td></tr>
                    <tr><td>łożyska koła z piastą</td><td>od 150 zł</td></tr>
                    <tr><td>tuleji wahacza</td><td>od 150 zł</td></tr>
                    <tr><td>wahacza</td><td>od 150 zł</td></tr>
                </tbody>

                <thead>
                    <tr>
                        <td colSpan={2}>Pozostałe</td>
                    </tr>
                </thead>
                <tbody>
                    <tr><td>Diagnostyka komputerowa</td><td>80 zł</td></tr>
                    <tr><td>Wymiana płynu chłodniczego</td><td>od 100 zł</td></tr>
                    <tr><td>Wymiana płynu hamulcowego</td><td>od 100 zł</td></tr>
                    <tr><td>Wymiana chłodnicy</td><td>od 150 zł</td></tr>
                    <tr><td>Wymiana rozrusznika</td><td>od 150 zł</td></tr>
                    <tr><td>Wymiana alternatora</td><td>od 150 zł</td></tr>
                    <tr><td>Wymiana świecy zapłonowej</td><td>od 20 zł</td></tr>
                    <tr><td>Wymiana świecy żarowej</td><td>od 50 zł</td></tr>
                    <tr><td>Wymiana żarówki</td><td>od 10 zł</td></tr>
                </tbody>
            </table> */}
            <p className="pricelist-disclaimer">{t("Powyższy cennik ma charakter poglądowy i nie stanowi oferty handlowej w rozumieniu art. 66 par. 1 Kodeksu Cywilnego.")}<br></br>{t("Dokładna cena usługi zostanie wskazana na miejscu po inspekcji pojazdu.")}</p>
        </div>
    )
}

export default Cennik;